import { render, staticRenderFns } from "./PropertiesChart.vue?vue&type=template&id=3500d011&"
import script from "./PropertiesChart.vue?vue&type=script&lang=ts&"
export * from "./PropertiesChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports